export enum CardSize {
  Sm = 'card-sm',
  Md = 'card-md',
  Lg = 'card-lg'
}
